




























import { Component, Vue, Watch, Prop } from 'vue-property-decorator'
import Element from 'element-ui'

@Component({
  components: {
  }
})
export default class PageList extends Vue {
  public name = 'PageList'
  //这个直接在子组件中 通过按钮触发来改变
  @Prop({ default: false })
  public showMore: boolean = false
  /** 是否显示更多查询条件 */
  @Prop({ default: true })
  public moreFilterBox!: boolean
  /** 是否显示默认查询条件 */
  @Prop({ default: true })
  public showFew!: boolean

  //分页控件相关参数
  @Prop({ default: true })
  public showPager!: boolean
  @Prop({ default: 0 })
  public totalCount!: number
  @Prop({ default: {} })
  public queryTerm!: any
  //分页控件页数，页码变动时的触发事件
  @Prop({ default: null })
  public pageEvent!: () => void

  //一页显示的行数
  public get pageSize(): number {
    let size = window.baseConfig.PageSize
    if (this.queryTerm && this.queryTerm.PageSize) {
      size = this.queryTerm.PageSize
    }
    return size
  }
  //当前页码
  public get pageIndex(): number {
    let currentPage = 1
    if (this.queryTerm && this.queryTerm.Page) {
      currentPage = this.queryTerm.Page
    }
    return currentPage
  }
  public created() { }

  public onPageClick(page: number) {
    if (this.pageEvent) {
      this.queryTerm.Page = page ? page : 1
      this.pageEvent()
    }
  }

  public onPageSizeChanged(size: number) {
    // window.baseConfig.PageSize = size
    if (this.pageEvent) {
      this.queryTerm.PageSize = size
      this.pageEvent()
    }
  }

  public $refs!: {
  }
}
